import React, { useState, useEffect } from 'react';
import Button from '@atlaskit/button';

import Form, { Field, CheckboxField } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';

import ModalDialog, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';

import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { closeModal, getObject, updateObjectName } from "api/actions";

import {
    CLOSE_MODAL,
    SHOW_MODAL,
    UPDATE_OBJECT_NAME,
    UPDATE_OBJECT_NAME_SUCCESS,
    UPDATE_OBJECT_NAME_FAILURE
} from 'constants/ActionTypes';

import MODAL_KEYS from 'components/Modals/keys';


const footer = (isLoading) => (props) => (
    <ModalFooter showKeyline={props.showKeyline}>
      <span />
      <Button appearance="primary" isLoading={isLoading} type="submit">
        Update
      </Button>
    </ModalFooter>
  );


function RenameObject(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [name, setName] = useState(null);
    const [id, setId] = useState(null);
    const [loading, setLoading] = useState(false);

    const close = () => {
      setName(null)
      setId(null)
      setIsOpen(false)
      props.closeModal({
          modalKey: '',
          closeModalKey: MODAL_KEYS.RENAME_OBJECT
      });
    }

    const open = (name, id) => {
      setIsOpen(true)
      setName(name)
      setId(id)  
    }

    const onFormSubmit = (data) => {
        const { name } = data;
    
        props.updateObjectName({ id, name })

        setName(name)
    };

    const delayedClose = () => {
        setTimeout(close, 200);
    }

    useEffect(() => {
        if (props.showModal) {
            // Only open the modal if all the necessary fields are available
            if (!isOpen) {
              if (props.showModal && props.info.name && props.id) {
                open(props.info.name, props.id)
            }
            }
        }


        switch(props.type) {
            case UPDATE_OBJECT_NAME:
                if (id === props.id) {
                    setLoading(true)
                }
                break;
            case UPDATE_OBJECT_NAME_SUCCESS:
                if (id === props.id) {
                    setLoading(false)

                    // Get the updated object, so every table that has it can update
                    props.getObject({ id })

                    delayedClose()

                    props.addNotification({
                        message: `Name update successful`,
                        level: 'success',
                    });
                }
                break;
            case UPDATE_OBJECT_NAME_FAILURE:
                if (id === props.id) {
                    setLoading(false)
                    props.addNotification({
                        message: `Name update failed`,
                        level: 'error',
                    });
                }
                break;
        }
    })
    
    return (
        <div
        >
          <ModalTransition>
            {isOpen && (
              <ModalDialog
                heading="Rename"
                onClose={close}
                components={{
                  Container: ({ children, className }) => (
                    <Form onSubmit={onFormSubmit}>
                      {({ formProps }) => (
                        <form {...formProps} className={className}>
                          {children}
                        </form>
                      )}
                    </Form>
                  ),
                  Footer: footer(loading),
                }}
              >
                <p>Enter the new name of the file or folder</p>
                <Field isRequired label="Name" name="name" defaultValue={name}>
                  {({ fieldProps }) => (
                    <Textfield {...fieldProps} />
                  )}
                </Field>
              </ModalDialog>
            )}
          </ModalTransition>
        </div>
      );
}

RenameObject.defaultProps = {
    info: {}
}


const dispatchToProps = (dispatch) => {
    return bindActionCreators({ closeModal, getObject, updateObjectName }, dispatch)
};

const mapStateToProps = (state, ownProps) => {
    const newState = {
        id: state.modalId,
        type: state.type
    };

    switch(state.type) {
        case SHOW_MODAL:
            const infoKeys = state.modalInfo ? Object.keys(state.modalInfo) : [];

            if (state.modalKey === MODAL_KEYS.RENAME_OBJECT && infoKeys.length > 0) {
                newState.showModal = true
                newState.info = state.modalInfo;
                newState.modalKey = state.modalKey;
            }
            break;
        case CLOSE_MODAL:
            if (state.closeModalKey === MODAL_KEYS.RENAME_OBJECT) {
                newState.showModal = false;
            }
            break;
    }

    return newState;
}

export default connect(mapStateToProps, dispatchToProps)(RenameObject);